module.exports = __webpack_public_path__ + "img/coreset.30a3fadc.svg";